import React from "react";
import PropTypes from "prop-types";
import DataCell from "./DataCell";

const RowItem = React.memo(
  ({ row, rowIndex, onOpenModal, dollerSign, headerLength }) => {
    const isSectionHeader =
      typeof row[0] === "string" &&
      row[0].trim() !== "" &&
      row.slice(1).every((cell) => cell === "");

    if (isSectionHeader) {
      return (
        <tr key={rowIndex}>
          <th colSpan={headerLength} className="section-header">
            {row[0]}
          </th>
        </tr>
      );
    }

    return (
      <tr key={rowIndex}>
        {row.map((cell, cellIndex) => (
          <React.Fragment key={cellIndex}>
            <DataCell
              cell={cell}
              dollerSign={dollerSign}
              onOpenModal={onOpenModal}
            />
          </React.Fragment>
        ))}
      </tr>
    );
  },
  (prev, next) => prev.row === next.row && prev.dollerSign === next.dollerSign
);
RowItem.displayName = "RowItem";

RowItem.propTypes = {
  row: PropTypes.array.isRequired,
  rowIndex: PropTypes.number,
  onOpenModal: PropTypes.func,
  dollerSign: PropTypes.string,
  headerLength: PropTypes.number
};

export default RowItem;
